// extracted by mini-css-extract-plugin
module.exports = {"mainAlert":"main-alert_mainAlert__5Rq5_"};